import { texts } from '../languages/fr';
import { TUNNEL_STEPS } from 'containers/tunnel/tunnelSteps';

// Function to format the tunnel name based on its parts
export const formatTunnelName = name => {
    const parts = name.split('_');
    const firstPart = parts[0].toUpperCase();
    const suffix = parts[1] === 'pm' ? texts.PERSONNE_MORALE : texts.PERSONNE_PHYSIQUE;

    return `${firstPart} ${suffix}`;
};

// Function to get the condition text based on its type and limit value
export const getConditionText = condition => {
    const typeMap = {
        is_greater_than: texts.ALERTS.GREATER_THAN,
        is_less_than: texts.ALERTS.LESS_THAN,
        is_equal_to: texts.ALERTS.EQUAL,
    };

    return `${typeMap[condition.type] || condition.type} ${condition.limitValue}`;
};

// Function to process tunnels and extract relevant data
export const processTunnels = (tunnels, tunnelActionResults) => {
    return tunnels.map(tunnel => {
        const tunnelActions =
            tunnelActionResults.find(result => result.tunnelId === tunnel.id)?.data || [];

        return {
            id: tunnel.id,
            name: formatTunnelName(tunnel.name),
            actions: tunnelActions.map(action => ({
                name: action.name,
                wrongCharacter: action.wrongCharacter,
                alertType: action.alertType,
                alertMessage: action.alertMessage,
                actionConditions: action.actionConditions,
                questions: action.questions,
            })),
            phases: tunnel.tunnelPhases.map(phase => ({
                name: phase.phase.name,
                steps: phase.tunnelSteps.map(step => ({
                    name: step.title || step.step.name,
                    mandatory: step.mandatory,
                    questions: (step.questions || []).map(question => ({
                        title: question.title,
                        answers: question.answers.map(answer => ({
                            title: answer.title,
                            score: answer.score,
                        })),
                    })),
                })),
            })),
        };
    });
};
export const isStatusOk = userTunnelStep => {
    const tsInfo = TUNNEL_STEPS.find(ts => ts.stepId === userTunnelStep?.tunnelStep?.step?.id);
    if (tsInfo) {
        return tsInfo.allowNext.includes(userTunnelStep.status);
    }
    return false;
};
